import { render, staticRenderFns } from "./SMSSignup.vue?vue&type=template&id=6398481d&scoped=true&"
import script from "./SMSSignup.vue?vue&type=script&lang=js&"
export * from "./SMSSignup.vue?vue&type=script&lang=js&"
import style0 from "./SMSSignup.vue?vue&type=style&index=0&id=6398481d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6398481d",
  null
  
)

export default component.exports